import { useContext, useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { isLeftClick, isPlainClick } from '../../utils/clickHelpers';
import { DuperbrowseStreamContext } from '../DuperbrowseStreamContextProvider/DuperbrowseStreamContext';
import { getNormalizedStreamItemId } from '../redux/helpers';
import useDuperbrowseScrollRestoration from './useDuperbrowseScrollRestoration';
import { getStreamItems } from '../redux/selectors';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
function useDuperbrowseLink(itemId, ref, onClick, disableScrollRestoration) {
    const { isLoggedIn  } = useContext(SessionContext);
    const noDuperbrowse = useFlag('ads_no_duper') && !isLoggedIn;
    const { loadDuperbrowse , stream  } = useContext(DuperbrowseStreamContext);
    const streamItems = useSelector((state)=>getStreamItems(state, stream));
    useDuperbrowseScrollRestoration([
        itemId
    ], ref, !disableScrollRestoration);
    useDebugValue(`Duperbrowse link for ${stream.streamId}/${itemId}`);
    return (e)=>{
        onClick && onClick(e);
        // only open duperbrowse if:
        // 1. our click wasn't canceled
        // 2. it's an unmodified left click
        // 3. it's actually inside the context stream
        if (!noDuperbrowse && !e.defaultPrevented && isLeftClick(e) && isPlainClick(e) && streamItems.some((i)=>getNormalizedStreamItemId(i) === itemId)) {
            e.preventDefault();
            loadDuperbrowse(itemId, stream);
        }
    };
}
export default useDuperbrowseLink;
